<template>
    <div class="home">
        <header-small></header-small>
        <div>
            <b-container>
                <b-row>
                    <b-col>
                        <h2>Das Ferienhaus</h2>
                        <div class="line-wrapper"><span class="line"></span></div>
                        <p>Das Ferienhaus liegt in ruhiger Lage am Wald und hat Pkw-Stellplätze auf dem Grundstück. Sie erwarten 1 kombinierter Wohn-Essraum mit kleiner Küche (Kühlschrank mit Tiefkühlfach, Geschirrspüler, Mikrowelle, Cerankochfeld), 1 Schlafzimmer mit Doppel- und Einzelbett, ausgestattet mit Dusche und WC, 1 kleiner offener Wohnraum mit Vorhang, großem Wäscheschrank und Eckcouch mit Schlaffunktion (190 x 140 cm). Im Keller ist eine zweite Dusche und Waschmaschine. SAT TV gibt es im Wohn-Essraum und im Schlafzimmer, ein Telefonanschluss ist möglich. Die Terrasse hat einen Gartengrill. Der Außenpool steht zur Verfügung (3,50 m, 1,20 m tief). Ebenfalls vorhanden sind Kinderkombihochstuhl, Kinderreisebett, Spielsachen, Sandkasten, Schaukel, Liegewiese, Bücher und Bügeleisen.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div style="background-color: #efefef">
            <outdoor-gallery></outdoor-gallery>
        </div>
        <div>
            <indoor-gallery></indoor-gallery>
        </div>
    </div>
</template>

<script>
import Parallax from 'vue-parallaxy'
import OutdoorGallery from '../components/OutdoorGallery'
import IndoorGallery from '@/components/IndoorGallery'
import AppDetails from '@/components/Details'
import Navigation from '@/components/Navigation'
import HeaderSmall from '@/components/HeaderSmall'

export default {
  name: 'home',
  metaInfo: {
    title: 'Ferienhaus Weber',
    htmlAttrs: {
      lang: 'de'
    },
    meta: [
      { name: 'description', content: 'Unser Ferienhaus liegt zentral zwischen dem Nationalpark Sächsische Schweiz und der Landeshauptstadt Dresden. Sie können Ihren Urlaub abwechslungsreich gestalten. Sie können Wandern, Klettern, Radfahren, oder Museen, Burgen und Städte besichtigen.' },
      { name: 'keywords', content: 'Sächsische Schweiz, Pirna, Dresden, Wanderung, Ländlich, Bergsteigen, Paddeln, Active Urlaub' }
    ]
  },
  components: {
    HeaderSmall,
    Navigation,
    IndoorGallery,
    Parallax,
    OutdoorGallery,
    AppDetails
  }
}
</script>
